import { create } from 'zustand';
import moment from 'moment-timezone';

interface InvoiceState {
  currentDate: Date;
  setCurrentDate: (date: Date) => void;
  selectedTimezoneName: string;
  setSelectedTimezoneName: (name: string) => void;
}
const defaultTimezoneName = moment.tz.guess();

export const useCalenderState = create<InvoiceState>((set) => ({
  currentDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  setCurrentDate: (date) => set({ currentDate: date }),
  selectedTimezoneName: defaultTimezoneName,
  setSelectedTimezoneName: (name) => set({ selectedTimezoneName: name }),
}));
